import { useQuery } from 'react-query';
import { format, zonedTimeToUtc, utcToZonedTime } from 'date-fns-tz';
import { parse } from 'date-fns';

import { DateTimeResponse, MonthInfo } from '../../api/date/ny';

export const fetchNYDate = async (): Promise<DateTimeResponse> => {
  const response = await fetch('/api/date/ny', {
    method: 'POST',
  });

  if (!response.ok) {
    throw new Error('Network response was not ok');
  }

  return response.json() as Promise<DateTimeResponse>;
};

export const useNYDate = () => {
  return useQuery<DateTimeResponse, Error>({
    queryKey: ['nyDate'],
    queryFn: fetchNYDate,
  });
};

export const toNYDate = async (
  year?: number,
  month?: number,
  day?: number,
): Promise<MonthInfo> => {
  const response = await fetch('/api/date/to-ny', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ year, month, day }),
  });

  if (!response.ok) {
    throw new Error('Network response was not ok');
  }

  return response.json() as Promise<MonthInfo>;
};

const NEW_YORK_TIMEZONE = 'America/New_York';

export function parseBackendDate(dateString: string): Date {
  // Parse the date string as if it were in the New York timezone
  const parsedDate = parse(
    dateString,
    "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'",
    new Date(),
  );

  // Convert the parsed date to a Date object in the New York timezone
  return zonedTimeToUtc(parsedDate, NEW_YORK_TIMEZONE);
}

export function formatDateForDisplay(date: Date, formatString: string): string {
  // Format the date for display, always in New York time
  return format(utcToZonedTime(date, NEW_YORK_TIMEZONE), formatString, {
    timeZone: NEW_YORK_TIMEZONE,
  });
}

// TODO: Add unit tests for this
export const parseAndFormatDate = (
  dateString: string,
  formatString: string,
): string => {
  const date = parseBackendDate(dateString);
  return formatDateForDisplay(date, formatString);
};
